module.exports = __webpack_public_path__ + "static/404-aa6e2b0ec361cf8c608c011c8ba65dda.png";